import { render } from "./FlipCardKit.ce.vue?vue&type=template&id=051c13f0"
import script from "./FlipCardKit.ce.vue?vue&type=script&lang=js"
export * from "./FlipCardKit.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__